export enum CalendarField {
  departure = 'departure',
  arrival = 'arrival'
}

export interface Day {
  value: number;
  date: Date;
  week: number;
  isToday: boolean;
  isWeekend: boolean;
  identifier: string;
  formatted: string;
  disabled?: boolean;
  selected?: boolean;
  minRange?: boolean;
  maxRange?: boolean;
  inRange?: boolean;
  inRangeRight?: boolean;
  inRangeLeft?: boolean;
  price?: number;
}
